import React, { useState, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { useSelector } from 'react-redux'

import trads from '../intl/trads.json'

import ButtonArrow from './buttonArrow'
import Slider from './slider'
import NewsCard from './cards/newsCard'
import SocialCard from './cards/socialCard'
import GetNewsroomUrls from '../utils/getNewsroomUrls'

const NewsroomNews = ({ news, socials, lang: propLang }) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const storeLang = useSelector(state => state.lang)
  const lang = propLang || storeLang
  const newsroomUrls = GetNewsroomUrls()

  const sliderItems = React.useMemo(() => {
    let calculatedItems = []
    let newsIndex = 0
    let socialIndex = 0

    // for each "page" of slider
    for (var i = 0; i < 3; i++) {
      let tempNewsRs = []
      const newsItem = news[newsIndex]

      // push news
      if (newsItem) {
        tempNewsRs.push(newsItem)
        newsIndex++
      } else {
        if (socials[socialIndex]) {
          tempNewsRs.push(socials[socialIndex])
          socialIndex++
        }
      }

      // push RS
      if (socials[socialIndex]) {
        tempNewsRs.push(socials[socialIndex])
        socialIndex++
      } else {
        if (news[newsIndex]) {
          tempNewsRs.push(news[newsIndex])
          newsIndex++
        }
      }
      
      if (socials[socialIndex]) {
        tempNewsRs.push(socials[socialIndex])
        socialIndex++
      } else {
        if (news[newsIndex]) {
          tempNewsRs.push(news[newsIndex])
          newsIndex++
        }
      }
      
      tempNewsRs = tempNewsRs.sort((a,b) => new Date(b.publicationDate ? b.publicationDate : b.external_created_at) - new Date(a.publicationDate ? a.publicationDate : a.external_created_at))

      calculatedItems = calculatedItems.concat(tempNewsRs)
    }

    return calculatedItems
  }, [news, socials])

  const sliderChildren = React.useMemo(() => {
    return sliderItems.map((item, i) => {
      let itemCard

      if (item !== undefined) {
        if (item.internal !== undefined ) {
          itemCard = <NewsCard news={item}  />
        } else {
          itemCard = <SocialCard social={item} />
        }
      }

      return (
        <div className={`scroll-anim-el w-full flex scroll-anim-el--${i + 1}`} key={i}>
          { itemCard }
        </div>
      )
    })
  }, [sliderItems])

  return (
    <>
      { sliderItems.length > 0 &&
        <section className={`slice ${inView ? 'has-anim' : ''} `} ref={ref}>
          <h2 className="title title-slice slider-cards-title">
           { trads[lang].newsroom.news }
          </h2>
          
          <div className="slider-cards">
            <Slider
              name="newsroom-featured" 
              hasCards="true"
              nbItems={sliderItems.length}
              options = '{ "slidesPerView": 1, "spaceBetween": 24,"breakpoints": { "768": { "slidesPerView": 2, "slidesPerGroup": 2, "spaceBetween": 32 }, "1280": { "slidesPerView": 3, "slidesPerGroup": 3, "spaceBetween": 32 }} }'>

              {sliderChildren}
            </Slider>
            
            <div className="scroll-anim-el scroll-anim-el--4">
              <ButtonArrow 
                text={ trads[lang].home.goNewsroom }
                link={`/${newsroomUrls['Actualités'][lang]}`}
                color="night" />
            </div>
          </div>

          <div className="sr-only" aria-hidden="true">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {[...news, ...socials].filter(item => item).map((item, i) => {
                let itemCard
                
                if (item.internal !== undefined) {
                  itemCard = <NewsCard news={item} />
                } else {
                  itemCard = <SocialCard social={item} />
                }

                return (
                  <div key={i}>
                    {itemCard}
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      }
    </>
  )
}

export default NewsroomNews